// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	ExtendCounselCreditToClientButtonSegmented:
		'extend-counsel-credit-to-client-button-segmented',
	CombinePremiumAndCounselCreditCheckbox:
		'combine-premium-and-counsel-credit-checkbox',
	SubjectToHstInStatementOfAccountCheckbox:
		'subject-to-hst-in-statement-of-account-checkbox',
	Note: 'note',
	TitleSection: 'title-section',
	SetDefaultProviderSelect: 'set-default-provider-select',
	Option: 'option',
	ShowCounselCreditAsFeeCheckbox: 'show-counsel-credit-as-fee-checkbox',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
